import { BUILD_DATE, BUILD_ISO } from '../buildInfo';

/**
 * Re-format the build timestamp to the user's CURRENT device timezone.
 * The build script writes BUILD_ISO in UTC; we convert at runtime so
 * the value shown matches the user's wall clock regardless of where
 * the build actually ran.
 */
const formatBuildLocal = () => {
  try {
    const d = new Date(BUILD_ISO);
    if (Number.isNaN(d.getTime())) return BUILD_DATE;
    return new Intl.DateTimeFormat(undefined, {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
      hour12: false,
    }).format(d);
  } catch (_) {
    return BUILD_DATE;
  }
};
/**
 * Collect a runtime snapshot useful for support triage.
 * Returns a structured object with grouped fields for nicer display.
 */
export const collectDiagnostics = () => {
  let cap = { isNative: false, platform: 'web' };
  try {
    if (typeof window !== 'undefined' && window.Capacitor) {
      cap = {
        isNative: !!window.Capacitor.isNativePlatform?.(),
        platform: window.Capacitor.getPlatform?.() || 'web',
      };
    }
  } catch (_) { /* capacitor not available */ }

  let userId = '';
  try { userId = localStorage.getItem('user_id') || ''; } catch (_) { /* storage blocked */ }

  // Concise UA: just the device + browser, not the full string.
  let uaShort = 'n/a';
  try {
    const ua = navigator.userAgent || '';
    const m = ua.match(/\(([^)]+)\)/);
    const inside = m ? m[1] : ua;
    uaShort = inside.length > 80 ? inside.slice(0, 80) + '…' : inside;
  } catch (_) { /* no navigator */ }

  return {
    'Build': formatBuildLocal(),
    'Bridge nativo': cap.isNative ? `sì — ${cap.platform}` : `no — ${cap.platform}`,
    'Dispositivo': uaShort,
    'Lingua': typeof navigator !== 'undefined' ? navigator.language : 'n/a',
    'Fuso orario': Intl?.DateTimeFormat?.().resolvedOptions?.().timeZone || 'n/a',
    'Online': typeof navigator !== 'undefined' ? (navigator.onLine ? 'sì' : 'no') : 'n/a',
    'Schermo': typeof window !== 'undefined'
      ? `${window.innerWidth} × ${window.innerHeight} @ ${window.devicePixelRatio || 1}x`
      : 'n/a',
    'API': (process.env.REACT_APP_BACKEND_URL || 'n/a').replace(/^https?:\/\//, ''),
    'Utente': userId || '— non loggato —',
    'Cattura': new Intl.DateTimeFormat(undefined, {
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
    }).format(new Date()),
  };
};

export const formatDiagnostics = (info) =>
  Object.entries(info)
    .map(([k, v]) => `${k}: ${v}`)
    .join('\n');
